import { AddImageButtonProps } from './Types'
import { track } from '@tldraw/tldraw'
import { observer } from 'mobx-react-lite'
import { ToolbarButton } from '../../components/ToolbarButton'
import { ImageAdd } from 'blaze-ui/icons'
import { useReplaceImage } from 'components/Design/ShapesTab/components/useReplaceImage'

const AddImageButton = track(
  observer(({ editor, selectedShape }: AddImageButtonProps) => {
    const { replace } = useReplaceImage({ editor, selectedShape })

    if (selectedShape.type !== 'mask') return null

    return (
      <ToolbarButton frontIcon={ImageAdd} onPress={replace}>
        Add Image
      </ToolbarButton>
    )
  }),
)

export { AddImageButton }
